/** модальное окно для пользователей */
import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import IntlMessages from "util/intlMessages";
import { adminAPI } from "redux/api";
import { FloatModal } from "components/special";
import { Finder } from "../../standart";

const { api } = adminAPI.actions;

const FloatUsers = (props) => {
  return (
    <FloatModal
      header={<IntlMessages id={"Users"} />}
      {...props}
      head={(searchUsers, searchQuery, setSearchQuery) => {
        return (
          <>
            <th>
              <Finder className="mr-1 d-inline" isActive={searchQuery.ident}>
                <Finder.input name="ident" {...{ query: searchQuery, setQuery: setSearchQuery }} />
              </Finder>
              <IntlMessages id="Users.ident" />
            </th>
            <th>
              <IntlMessages id="Users.name" />
            </th>
            <th>
              <Finder className="mr-1 d-inline" isActive={searchQuery.username}>
                <Finder.input
                  name="username"
                  {...{ query: searchQuery, setQuery: setSearchQuery }}
                />
              </Finder>
              <IntlMessages id="Users.login" />
            </th>
            <th style={{ width: "30px" }}></th>
          </>
        );
      }}
      row={(user, clickHandler) => {
        return (
          <>
            <td onClick={clickHandler} className={!user.enabled ? "text-strike" : ""}>
              {user.ident}
            </td>
            <td onClick={clickHandler} className={!user.enabled ? "text-strike" : ""}>
              {user.profile?.name}
            </td>
            <td onClick={clickHandler} className={!user.enabled ? "text-strike" : ""}>
              {/* {user.name} */}
              {user.profile?.username}
            </td>
            <td></td>
          </>
        );
      }}
    />
  );
};

export default connect(null, {
  getData: api.get("/api/users"),
})(FloatUsers);
